import Head from 'next/head';
import type { JSX } from 'react';

interface Props {
  title: string;
}

export function HeadTitle({ title }: Props): JSX.Element {
  return (
    <Head>
      <title>{title}</title>
    </Head>
  );
}
